module.exports = __webpack_public_path__ + "media/images/mobile-only/element05-8b8ced2ed1b4f67ab4e0a69145bd1086.png";